import IcaLayout from "./IcaLayout.tsx";
import { AppPaths } from "./globals";
import ErrorPage from "./ErrorPage.tsx";
import MockPage from "./MockPage.tsx";
import { isNonProd, isStaging } from "./utils/env.ts";

const childrenRoutes = [];

if (process.env.VITE_USE_MOCK === "true" || isNonProd() || isStaging()) {
  childrenRoutes.push({
    path: AppPaths.MOCK_PAGE.path,
    element: <MockPage />,
  });
}

const routesConfig = [
  {
    element: <IcaLayout />,
    errorElement: <ErrorPage />,
    children: childrenRoutes,
  },
];

export default routesConfig;
